/**
 * The hierarchy `ADMIN > SALES` is applied by the backend, which returns the expanded set as
 * `effectiveRoles` — there is deliberately no copy of it here.
 */
export const Role = {
  ADMIN: 'ADMIN',
  SALES: 'SALES',
} as const

export type Role = (typeof Role)[keyof typeof Role]

/** The roles an administrator can hand out, in the order they are offered. */
export const ASSIGNABLE_ROLES: readonly Role[] = [Role.SALES, Role.ADMIN]
